var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('Banner'),_c('Collections'),_c('ProductsSection',{attrs:{"title":"新品上市","subtitle":"New Arrivals","productType":"new"}}),_c('ProductsSection',{attrs:{"title":"熱銷榜單","subtitle":"ＲＡＮＫＩＮＧ","productType":"sale"}}),_c('NewsSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }